module.exports = __webpack_public_path__ + "img/1472826500.ed3338e9.jpg";